import { memo } from "react"
import { IconSliders3Outline18 as OptionsIcon } from "nucleo-ui-outline-18"
import { create } from "zustand"
import { persist } from "zustand/middleware"

import { IconButton, Popover, Switch } from "@productlane/ui"

interface AgentListOptionsState {
	showAccepted: boolean
	showDeclined: boolean
	showLinked: boolean
	set: (
		patch: Partial<
			Pick<
				AgentListOptionsState,
				"showAccepted" | "showDeclined" | "showLinked"
			>
		>,
	) => void
}

// A reading preference, so it stays in this browser.
export const useAgentListOptions = create<AgentListOptionsState>()(
	persist(
		(set) => ({
			showAccepted: false,
			showDeclined: false,
			showLinked: false,
			set: (patch) => set(patch),
		}),
		{ name: "agent-list-options" },
	),
)

const OptionRow = memo(
	({
		label,
		checked,
		onCheckedChange,
	}: {
		label: string
		checked: boolean
		onCheckedChange: (checked: boolean) => void
	}) => (
		<label className="flex h-9 cursor-default items-center justify-between gap-6 px-3 text-sm text-primary">
			{label}
			<Switch
				label={null}
				name={label}
				size="small"
				checked={checked}
				onCheckedChange={onCheckedChange}
			/>
		</label>
	),
)

/** The Agent list's view options, like the inbox's: which decided cards to list. */
export const AgentListOptions = memo(() => {
	const { showAccepted, showDeclined, showLinked, set } = useAgentListOptions()
	return (
		<Popover
			align="end"
			// Non-modal: a modal popover blocks the page through its exit animation, so
			// the next click (often the assistant toggle beside it) did nothing.
			modal={false}
			className="w-60 p-1"
			content={
				<div className="flex flex-col py-1">
					<OptionRow
						label="Show accepted"
						checked={showAccepted}
						onCheckedChange={(value) => set({ showAccepted: value })}
					/>
					<OptionRow
						label="Show declined"
						checked={showDeclined}
						onCheckedChange={(value) => set({ showDeclined: value })}
					/>
					<OptionRow
						label="Show Linear issues"
						checked={showLinked}
						onCheckedChange={(value) => set({ showLinked: value })}
					/>
				</div>
			}
		>
			<IconButton
				variant="ghost"
				aria-label="View options"
				Icon={OptionsIcon}
			/>
		</Popover>
	)
})
